import { Component, ElementRef, Inject, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ClientFilterSubscriptionRequest, ManagementClientControllerService, ManagementClientResponse, ManagementClientSubscriptionControllerService } from 'api-client';
import { Subject } from 'rxjs/internal/Subject';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { startWith } from 'rxjs/internal/operators/startWith';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { UtilsService } from '../../../../shared/services/utils.service';
import { take } from 'rxjs/internal/operators/take';
import { ClientReportByMailRequest, ManagementContractNoticeAndAnnouncementResponse, ManagementContractNoticesReportControllerService } from 'api-contract-notices';
import { SharedService } from '../../../../shared/services/shared.service';
import { ClientReportByMailRequest as ClippingClientReportByMailRequest, ManagementClipReportControllerService } from 'api-clipping';

@Component({
	selector: 'app-send-report-form',
	standalone: true,
	imports: [
		MatDialogModule,
		TranslateModule,
		MatIconModule,
		MatButtonModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatInputModule,
		MatDividerModule,
		MatProgressSpinnerModule,
		MatAutocompleteModule,
		MatChipsModule,
	],
	templateUrl: './send-report-form.component.html',
	styleUrl: './send-report-form.component.scss',
})
export class SendReportFormComponent implements OnDestroy {
	private onDestroy: Subject<any> = new Subject();
	formGroup: FormGroup = new FormGroup({});
	apiLoading = false;

	clientList: ManagementClientResponse[] = [];
	@ViewChild('clientsInput', { static: false }) clientsInput!: ElementRef<HTMLInputElement>;
	filteredClients: ManagementClientResponse[] = [];
	selectedClients: ManagementClientResponse[] = [];

	private allEmails: string[] = [];
	@ViewChild('emailsInput', { static: false }) emailsInput!: ElementRef<HTMLInputElement>;
	filteredEmails: string[] = [];
	selectedEmails: string[] = [];

	constructor(
		private dialogRef: MatDialogRef<SendReportFormComponent>,
		@Inject(MAT_DIALOG_DATA) private data: any,
		private fb: FormBuilder,
		public utils: UtilsService,
		private apiClient: ManagementClientControllerService,
		private apiManagementClientSubscritpion: ManagementClientSubscriptionControllerService,
		private apiContractNoticesReport: ManagementContractNoticesReportControllerService,
		private apiClippingReport: ManagementClipReportControllerService,
		private sharedService: SharedService,
		private translate: TranslateService
	) {
		// this.getClientList();
		this.initializeForm();
	}

	ngOnDestroy(): void {
		this.onDestroy.next(null);
	}

	private initializeForm() {
		this.formGroup = this.fb.group({
			// clients: [],
			emails: [],
		});
		this.formControlWatchers();
	}

	private formControlWatchers() {
		// this.formGroup.controls['clients'].valueChanges.pipe(startWith(''), debounceTime(450), distinctUntilChanged(), takeUntil(this.onDestroy)).subscribe(searchTerm => {
		//   this.search('CLIENTS', searchTerm);
		// });

		this.formGroup.controls['emails'].valueChanges.pipe(startWith(''), debounceTime(450), distinctUntilChanged(), takeUntil(this.onDestroy)).subscribe(searchTerm => {
			this.search('EMAILS', searchTerm);
		});
	}

	private search(type: 'CLIENTS' | 'EMAILS', searchTerm: string) {
		switch (type) {
			// case 'CLIENTS': {
			// 	if (searchTerm) {
			// 		this.filteredClients = this.clientList.filter(item => item.name?.toLowerCase().includes(searchTerm.toLowerCase()));
			// 	} else {
			// 		this.filteredClients = JSON.parse(JSON.stringify(this.data.clientList));
			// 	}
			// 	break;
			// }
			case 'EMAILS': {
				if (searchTerm) {
					this.filteredEmails = this.allEmails.filter(item => item.toLowerCase().includes(searchTerm.toLowerCase()));
				} else {
					this.filteredEmails = JSON.parse(JSON.stringify(this.allEmails));
				}
				break;
			}
		}
	}

	action(
		type: 'SEND' | 'VALIDATION' | 'REMOVE_ITEM' | 'ADD_ITEM',
		dataType?: 'CLIENTS' | 'EMAILS',
		data?: MatChipInputEvent | ManagementClientResponse | MatAutocompleteSelectedEvent | string
	) {
		switch (type) {
			case 'SEND': {
				if (this.data.dataAdministrationType === 'CLIPPING') {
					this.sentClippingReportToClients();
				} else {
					this.sentContractNoticesReportToClients();
				}
				break;
			}
			case 'VALIDATION': {
				const emailPattern: RegExp = new RegExp(this.utils.VALIDATION_PATTERNS.get('E_MAIL') || '');
				return this.selectedClients.length > 0 || this.selectedEmails.length > 0; //|| emailPattern.test(this.formGroup.controls['emails'].value);
			}
			case 'REMOVE_ITEM': {
				// if (dataType === 'CLIENTS') {
				// 	this.selectedClients = this.selectedClients.filter(item => item.id !== (data as ManagementClientResponse).id);
				// 	this.getClientsSubscriptions();
				// } else
				if (dataType === 'EMAILS') {
					this.selectedEmails = this.selectedEmails.filter(item => item !== (data as string));
				}
				break;
			}
			case 'ADD_ITEM': {
				// if (dataType === 'CLIENTS') {
				// 	this.selectedClients.push((data as MatAutocompleteSelectedEvent).option.value);
				// 	this.formGroup.controls['clients'].setValue(null);
				// 	this.clientsInput.nativeElement.value = '';
				// 	this.getClientsSubscriptions();
				// } else
				if (dataType === 'EMAILS') {
					this.selectedEmails.push((data as MatChipInputEvent).value);
					this.formGroup.controls['emails'].setValue(null);
					this.emailsInput.nativeElement.value = '';
				}
				break;
			}
			default: {
				this.closeDialog();
			}
		}
		return false;
	}

	// private getClientList() {
	// 	const clientFilterSubscriptionRequest: ClientFilterSubscriptionRequest = {
	// 		subscriptions: [
	// 			'CONTRACT_NOTICES',
	// 			'CONTRACT_NOTICES_KOSOVO',
	// 			'CONTRACT_NOTICES_ALBANIA',
	// 			'CONTRACT_NOTICES_ANNOUNCEMENTS',
	// 			'CONTRACT_NOTICES_ANNOUNCEMENTS_KOSOVO',
	// 			'CONTRACT_NOTICES_ANNOUNCEMENTS_ALBANIA',
	// 		],
	// 		status: undefined,
	// 	};

	// 	this.apiClient
	// 		.getClients(clientFilterSubscriptionRequest, 0, 1000)
	// 		.pipe(take(1))
	// 		.subscribe({
	// 			next: response => {
	// 				if (response.content) {
	// 					this.clientList = response.content;
	// 				}
	// 			},
	// 			error: () => {
	// 				// Handle error
	// 			},
	// 		});
	// }

	// private getClientsSubscriptions() {
	// 	this.allEmails = [];
	// 	this.filteredEmails = [];
	// 	this.selectedClients.forEach(client => {
	// 		this.apiManagementClientSubscritpion
	// 			.getClientSubscriptions(client.id)
	// 			.pipe(take(1))
	// 			.subscribe({
	// 				next: response => {
	// 					response.forEach(item => {
	// 						if (item.type === 'CONTRACT_NOTICES' && item.emailTo) {
	// 							this.allEmails.push.apply(this.allEmails, item.emailTo);
	// 						}
	// 					});
	// 					this.filteredEmails.push.apply(this.filteredEmails, this.allEmails);
	// 				},
	// 			});
	// 	});
	// }

	private sentContractNoticesReportToClients() {
		this.apiLoading = true;
		let selectedIds: string[] = [];
		const contractAnnouncementAsNoticeIds: string[] = [];

		if (this.data.dataAdministrationType === 'CONTRACT_NOTICES') {
			this.data.selectedItems.forEach((item: ManagementContractNoticeAndAnnouncementResponse) => {
				if (item.id) {
					if (item.announcementType === 'MODIFICATION' || item.announcementType === 'CANCELLATION') {
						contractAnnouncementAsNoticeIds.push(item.id);
					} else {
						selectedIds.push(item.id);
					}
				}
			});
		} else {
      selectedIds = this.data.selectedItems.map((item: any) => item.id);
    }

		const clientReportByMailRequest: ClientReportByMailRequest = {
			emailsBcc: this.selectedEmails,
			contractNoticeIds: this.data.dataAdministrationType === 'CONTRACT_NOTICES' ? selectedIds : [],
			contractAnnouncementIds: this.data.dataAdministrationType === 'CONTRACT_ANNOUNCEMENTS' ? selectedIds : [],
			contractAnnouncementAsNoticeIds,
			saleIds: this.data.dataAdministrationType === 'SALES' ? selectedIds : [],
			bankruptcyIds: this.data.dataAdministrationType === 'BANKRUPTCIES' ? selectedIds : [],
			lang: this.utils.currentLanguage.toUpperCase() as ClientReportByMailRequest.LangEnum,
		};
		this.apiContractNoticesReport
			.sendReportFromMail(clientReportByMailRequest)
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.REPORT_SENT'),
						type: 'SUCCESS',
					});
					this.apiLoading = false;
					this.closeDialog();
				},
				error: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR'),
						type: 'ERROR',
					});
					this.apiLoading = false;
					// this.closeDialog();
				},
			});
	}

	private sentClippingReportToClients() {
		this.apiLoading = true;
		const groupIds = new Set<string>();
		this.data.selectedItems.forEach((item: any) => groupIds.add(item.groupId));
		const clientReportByMailRequest: ClippingClientReportByMailRequest = {
			emailsBcc: this.selectedEmails,
			groupIds: Array.from(groupIds),
			lang: this.utils.currentLanguage.toUpperCase() as ClientReportByMailRequest.LangEnum,
		};
		this.apiClippingReport
			.sendReportFromMail(clientReportByMailRequest)
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.REPORT_SENT'),
						type: 'SUCCESS',
					});
					this.apiLoading = false;
					this.closeDialog();
				},
				error: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR'),
						type: 'ERROR',
					});
					this.apiLoading = false;
					// this.closeDialog();
				},
			});
	}

	closeDialog() {
		this.dialogRef.close();
	}
}
